import type {
  BetaDisplayMode,
  MobileView,
} from '@/__experimental__/SEARCH_BETA_SPIKE/spike.types'

// Spike-local on purpose: the shared parseDisplayMode only knows MAP | LIST.
const BETA_DISPLAY_MODES: BetaDisplayMode[] = ['LIST', 'GRID', 'MAP']

const MOBILE_VIEW_BY_DISPLAY_MODE: Record<BetaDisplayMode, MobileView> = {
  LIST: 'list',
  GRID: 'grid',
  MAP: 'map',
}

export const DISPLAY_MODE_BY_MOBILE_VIEW: Record<MobileView, BetaDisplayMode> =
  {
    list: 'LIST',
    grid: 'GRID',
    map: 'MAP',
  }

/** Case-insensitive; anything other than a single known value is undefined. */
export const parseBetaDisplayMode = (
  value: unknown,
): BetaDisplayMode | undefined => {
  if (typeof value !== 'string') return undefined

  const upperCaseValue = value.toUpperCase()
  return BETA_DISPLAY_MODES.find((mode) => mode === upperCaseValue)
}

/**
 * Below 768px: MAP opens the map, GRID or no mode the grid, LIST the list.
 * From 768px the map is always shown, so the mode has no effect there.
 */
export const getInitialMobileView = (mode?: BetaDisplayMode): MobileView =>
  mode ? MOBILE_VIEW_BY_DISPLAY_MODE[mode] : 'grid'
